module.exports = __webpack_public_path__ + "static/media/close.dc2c7537.svg";